import React, { useState } from 'react';
import { Flame, X } from 'lucide-react';
import { Card } from './ui/card';
import { Dialog, DialogContent } from './ui/dialog';

export const Gallery = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="gallery" className="relative py-24 bg-black">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(220, 38, 38, 0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(220, 38, 38, 0.3) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="h-px w-12 bg-red-600"></div>
            <Flame className="w-8 h-8 text-red-600" />
            <div className="h-px w-12 bg-red-600"></div>
          </div>
          <h2 className="text-5xl sm:text-6xl font-black text-white mb-6 tracking-tight">
            GALERIA
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Veja a intensidade e o calor que o Rasputin proporciona
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <Card
              key={image.id}
              className="group relative overflow-hidden bg-zinc-900 border-2 border-red-900/30 hover:border-red-600 transition-all duration-300 cursor-pointer"
              onClick={() => setSelectedImage(image)}
            >
              {/* Image */}
              <div className="aspect-square overflow-hidden">
                <img
                  src={image.image}
                  alt={image.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                <div>
                  <h3 className="text-2xl font-black text-white mb-2">
                    {image.title}
                  </h3>
                  <div className="flex items-center gap-2">
                    <Flame className="w-5 h-5 text-red-600" />
                    <span className="text-red-500 font-bold text-sm">VER DETALHES</span>
                  </div>
                </div>
              </div>

              {/* Corner Accent */}
              <div className="absolute top-0 right-0 w-20 h-20 bg-red-600/20 blur-2xl group-hover:bg-red-600/40 transition-all duration-300"></div>
            </Card>
          ))}
        </div>
      </div>

      {/* Image Modal */}
      <Dialog open={selectedImage !== null} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-4xl bg-black border-2 border-red-600 p-0">
          {selectedImage && (
            <div className="relative">
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 z-20 w-10 h-10 bg-red-600 hover:bg-red-700 rounded-full flex items-center justify-center transition-colors duration-300"
              >
                <X className="w-6 h-6 text-white" />
              </button>
              <img
                src={selectedImage.image}
                alt={selectedImage.title}
                className="w-full h-auto"
              />
              <div className="p-8 bg-gradient-to-t from-black to-transparent absolute bottom-0 left-0 right-0">
                <h3 className="text-3xl font-black text-white mb-2">
                  {selectedImage.title}
                </h3>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
